// extracted by mini-css-extract-plugin
module.exports = {"vertical-seperator":"SchedulesView_vertical-seperator_2yNlb"};